import React, { useState } from 'react';
import PropTypes, { any } from 'prop-types';

import {
    TitleSwitch,
} from '../../../Form';

const AllowMultiRegistrations = ({ formApi }) => {
    const { values, setValue } = formApi;
    const [isMultiRegistrationAllowed, setIsMultiRegistrationAllowed] = useState(values?.isMultiRegistrationAllowed || false);
    const multiRegistrationFormValue = 'isMultiRegistrationAllowed';

    const toggleAllowMultiRegistrations = () => {
        if (isMultiRegistrationAllowed) {
            setIsMultiRegistrationAllowed(!isMultiRegistrationAllowed);
            setValue(multiRegistrationFormValue, false);
        } else {
            setIsMultiRegistrationAllowed(!isMultiRegistrationAllowed);
            setValue(multiRegistrationFormValue, true);
        }
    };

    return (
        <div className="col-12">
            <div className={`form-block-content`}>
                <div className="row">
                    <div className="col-12">
                        <div className="div div16" />
                        <TitleSwitch
                            id="multiRegistrations"
                            formGroupCssClass={`mt16`}
                            label={'Multiplayer Checkout'}
                            description={`If enabled, parents or players will be able to checkout and pay for multiple player registrations at the same time.`}
                            value={isMultiRegistrationAllowed}
                            onChange={toggleAllowMultiRegistrations}
                            data-testid="event-edit.multi-registrations-title-switch"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

AllowMultiRegistrations.propTypes = {
    formApi: PropTypes.objectOf(any).isRequired,
};

export default AllowMultiRegistrations;
